export default "__VITE_ASSET__BuTATlOx__"